export const PRICING = {
  PRO: {
    monthly: 790, // RUB
    yearly: 6715, // RUB (29% discount versus 12 monthly payments)
  },
} as const

/** Default request limits per plan (may differ from DB) */
export const PLAN_LIMITS = {
  FREE: 35,
  STANDARD: 250,
  PRO: null,
} as const satisfies Record<string, number | null>

export type PlanType = keyof typeof PRICING
export type IntervalType = 'Month' | 'Year'

export function getPrice(plan: PlanType, interval: IntervalType): number {
  return PRICING[plan][interval === 'Month' ? 'monthly' : 'yearly']
}
